import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=20eb0770&"
import script from "./Automation.vue?vue&type=script&lang=js&"
export * from "./Automation.vue?vue&type=script&lang=js&"
import style0 from "./Automation.vue?vue&type=style&index=0&id=20eb0770&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports